export default "__VITE_ASSET__DjwPHsDD__"